var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"all-box"},[_c('img',{attrs:{"src":require("./imgs/img-logo-icon-img.png"),"alt":""}}),_c('p',[_vm._v("页面出错误了 ~")])])}]

export { render, staticRenderFns }